module.exports = __webpack_public_path__ + "public/img/ico-battery-status-error.c0195cd2.svg";